export default __webpack_public_path__ + "static/media/tip22.d41bc1b4.png";